// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"b2-z","dimensionLabel":"c2-z","styleChooserControlWrapper":"d2-z","styleChooserControl":"e2-z","disabled":"f2-z","giftCard":"g2-z","styleChooserText":"h2-z"};